import React from "react";

import { COLORS } from "@tSurya/theme/design.mgbw";

const MGBWChevronDownIcon: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="none">
            <g transform="translate(2.10, 5.74)">
                <path d="M14.8213 0.446289C14.9724 0.295214 15.1995 0.295214 15.3506 0.446289C15.501 0.596713 15.5017 0.822565 15.3525 0.973633L8.16504 8.03613L8.16309 8.03809C8.03553 8.16564 7.95906 8.19043 7.89844 8.19043C7.80009 8.19043 7.71649 8.16214 7.61133 8.0791L0.444336 1.03613C0.295208 0.885065 0.295865 0.659213 0.446289 0.508789C0.597364 0.357714 0.824511 0.357714 0.975586 0.508789L0.978516 0.511719L7.66602 7.04297L7.89941 7.27148L8.13281 7.04199L14.8203 0.448242L14.8213 0.446289Z" fill={COLORS.primary.base} stroke={COLORS.primary.base} strokeWidth="0.666667"/>
            </g>
        </svg>
    );
};

export default React.memo(MGBWChevronDownIcon);
